import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { IReport, ReportCommentCategory } from '@app/core/reports';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CommentsService, ReportComment } from '../../service/comments.service';
import { Table } from 'primeng/table';
import { FileService } from '@app/core/files';

@Component({
  selector: 'afoone-comment-dialog',
  templateUrl: './comment-dialog.component.html',
  styleUrls: ['./comment-dialog.component.css'],
})
export class CommentDialogComponent implements OnInit {
  public report: IReport;
  public form;
  public categories: ReportCommentCategory[] = [];
  public comments: ReportComment[] = [];
  public selectedFile?: File;

  @ViewChild('myTable') table!: Table;

  constructor(
    public config: DynamicDialogConfig,
    private fb: FormBuilder,
    private commentService: CommentsService,
    private fileService: FileService
  ) {
    if (config.data?.report) {
      this.report = config.data.report;
      this.categories = this.report.categories || [];
    }

    //Create the form for the comment
    this.form = this.fb.group({
      comment: '',
      category: undefined,
      file: [null], // This will hold the file object
    });
  }

  onFileSelected(file: File) {
    this.selectedFile = file;
  }

  async loadComments(): Promise<void> {
    const retrievedComments: ReportComment[] =
      (await this.commentService.getCommentsByReport(this.report.id))?.data ||
      [];
    this.comments = (retrievedComments || []).map(
      (comment: ReportComment): ReportComment => ({
        ...comment,
        createdAt: new Date(comment.createdAt),
      })
    );
  }

  scrollToTop() {
    const scrollableBody = this.table?.el.nativeElement.querySelector(
      '.p-datatable-wrapper'
    );
    console.log({ scrollableBody });
    if (scrollableBody) {
      scrollableBody.scrollTop = 0;
    }
  }

  ngOnInit(): void {
    this.loadComments();
  }

  downloadFile(filename: string): void {
    if (!filename) {
      console.error('No filename provided for download');
      return;
    }
    // the file is on attachments/{filename} in the backend
    this.fileService.getFile(`attachments/${filename}`).catch((error) => {
      console.error('Error downloading file:', error);
      // Optionally, show an error message to the user
    });
  }

  async saveComment(): Promise<void> {
    this.form.markAllAsTouched();

    if (!this.form.valid) {
      return;
    }

    // Here you would typically send the comment to the server

    try {
      const file: File | null = this.form.value.file;
      console.log('File to upload:', file);
      let responseFile: { filename?: string } | undefined;
      if (file) {
        responseFile = await this.fileService.uploadFile(file);
        console.log('File uploaded successfully:', responseFile);
      }

      await this.commentService.createComment(
        this.report.id,
        this.form.value.comment,
        this.form.value.category,
        responseFile?.filename
      );

      // Reset the comment value in the form
      this.form.patchValue({ comment: '' });
      // After saving the comment, reload the comments
      this.loadComments();
      this.scrollToTop();

      // 2. Si hay archivo, subirlo y asociarlo (por ejemplo, pasando savedComment.id)
      if (this.selectedFile) {
        await this.fileService.uploadFile(this.selectedFile);
      }

      this.form.reset();
      this.selectedFile = undefined;
      // recarga comentarios si hace falta
    } catch (error) {
      // this.toastrService.error('Error saving comment or uploading file', 'Error');
      console.error(error);
    }
  }

  // Close the dialog and pass the comment
  // this.config.clo
}
